import {Component, DestroyRef, inject} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatFormField, MatLabel, MatError} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent} from '@angular/material/card';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TranslocoModule} from '@jsverse/transloco';
import {EmailVerificationService} from '../../services/email-verification.service';

// Story 28.3 AC4 — landed here by the verify-email Lambda when a verification
// link is invalid/expired/consumed. Lets the user request a fresh link by
// entering their email; client_id rides in from the query string. Anti-
// enumeration: a confirmation is always shown (mirrors forgot-password).
@Component({
  selector: 'app-verify-email-error',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField, MatLabel, MatError, MatInput,
    MatButton,
    MatCard, MatCardContent,
    RouterLink,
    TranslocoModule,
  ],
  templateUrl: './verify-email-error.component.html',
  styleUrl: './verify-email-error.component.css',
})
export class VerifyEmailErrorComponent {
  form: FormGroup;
  loading = false;
  submitted = false;
  protected clientId = '';

  private readonly emailVerificationService = inject(EmailVerificationService);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.clientId = params['client_id'] || '';
    });
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  submit(): void {
    if (this.form.invalid || this.loading) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;
    const email = this.form.get('email')!.value.trim();
    this.emailVerificationService.resendVerification(email, this.clientId).subscribe({
      next: () => { this.loading = false; this.submitted = true; },
      error: () => { this.loading = false; this.submitted = true; },
    });
  }
}
